export default "__VITE_ASSET__C40AywAX__"